import { FC } from 'react'
import { Trans } from 'react-i18next'
import { Link } from '../Link'
import s from './Footer.module.css'

const Footer: FC = () => {
  return (
    <footer className={s.copyright}>
      <Trans i18nKey="Powered by<br/><2><0></0></2>">
        Powered by
        <br />
        <Link href="https://xoda.com/" target="_blank">
          <img src="/images/logo.svg" alt="Xoda" />
        </Link>
      </Trans>
    </footer>
  )
}

export { Footer }
